module.exports = __webpack_public_path__ + "static/media/disc_init.b681eb7d.png";